import styled from 'styled-components';

export const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
`;

export const DetailHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 32px 16px;
  flex-shrink: 0;
`;

export const DetailHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.spacing.sm};
`;

export const DetailContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0 32px ${(props) => props.theme.spacing.md};
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing.xxl};
  min-height: 0;
`;

export const AboutCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${(props) => props.theme.colors.ghostWhite};
  border: 1px solid ${(props) => props.theme.colors.dividerGray};
  border-radius: ${(props) => props.theme.borderRadius.base};
  padding: ${(props) => props.theme.spacing.sm};
`;

export const AboutCardText = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing.xs};
`;

export const BestForCard = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${(props) => props.theme.spacing.sm};
  background: ${(props) => props.theme.colors.aliceBlue};
  border-radius: ${(props) => props.theme.borderRadius.base};
  padding: ${(props) => props.theme.spacing.sm};
`;

export const BestForCardContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const PreviewSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing.md};
`;

export const PreviewHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SizeButtonGroup = styled.div`
  display: flex;
  gap: ${(props) => props.theme.spacing.xs};
`;

export const PreviewArea = styled.div`
  background: #F6F9FF;
  border-radius: ${(props) => props.theme.borderRadius.base};
  height: 48vh;
  display: flex;
  align-items: stretch;
  overflow: hidden;
`;

export const DetailFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 8px 32px 16px;
  flex-shrink: 0;
`;
